<template>
  <div id="main" class="index">
    <topNav></topNav>
    <div class="lawcDetail">
      <div class="backconbox">
        <div
          class="backcon"
          @mouseenter="mosein"
          @mouseout="mouseout"
          @click="backfun"
        >
          <img class="backconImg" :src="imgsrc" alt="" />
          <span class="backconSpan">返回公司动态列表</span>
        </div>
      </div>
      <div class="inline-title" v-html="html.title"></div>
      <div class="inline-html" v-html="html.html"></div>
    </div>
    <Bottoms></Bottoms>
  </div>
</template>

<script>
import topNav from "../sub/topNav";
import Bottoms from "../sub/Bottoms";
export default {
  name: "B05_gsdt",
  components: { topNav, Bottoms },
  data() {
    return {
      imgsrc: require("../../common/images/lawColumn/backicon.png"),
      html: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.initfun(this.$route.query.id);
  },
  methods: {
    initfun: function (id) {
      this.$api.viewDT(id).then((res) => {
        if (res.code == 0) {
          this.html = res.data;
        }
      });
    },
    backfun: function () {
      this.$router.push({ path: "/about?index=" + 5 });
    },
    mosein: function () {
      this.imgsrc = require("../../common/images/lawColumn/backiconr.png");
    },
    mouseout: function () {
      this.imgsrc = require("../../common/images/lawColumn/backicon.png");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  text-align: left;
}
.index {
  background: rgba(244, 244, 244, 1);
}
.lawcDetail {
  width: 1100px;
  overflow: hidden;
  opacity: 1;
  margin: 0 auto;
  min-height: 536px;
  background: rgba(255, 255, 255, 1);
}
.backconbox {
  width: 100%;
  overflow: hidden;
}
.backcon {
  display: inline-block;
  float: left;
  width: auto;
  height: 22px;
  overflow: hidden;
  line-height: 22px;
  margin: 0 24px;
  box-sizing: border-box;
  margin-top: 24px;
  margin-bottom: 26px;
  cursor: pointer;
}
.backcon:hover .backconSpan {
  color: #e7413b;
}

.backcon span {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #666666;
  opacity: 1;
  padding-left: 12px;
}
.backcon img {
  padding: 2px 0;
}
.backcon span,
.backcon img {
  display: inline-block;
  float: left;
}
.inline-html {
  width: 676px;
  padding-bottom: 30px;
  overflow: hidden;
  margin: 0 auto;
}
.inline-title{
    width: 676px;
  margin: 0 auto 0px;
  overflow: hidden;
  text-align: center;
  font-family:'宋体';
  font-weight: 900;
  line-height: 50px;
  font-size: 24px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutS/B05_gsdt.vue